// The tick-box choices for sending videos, remembered on this device and shared by every video upload on THE WALL.
import { useEffect, useState } from "react";

const KEY = "wall.videoSend.v1";
export const DEFAULTS = { shrink: true, size: 1080, soundOnly: false, resume: true, awake: true };

export const readPrefs = () => {
  try { return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || "{}") }; } catch { return { ...DEFAULTS }; }
};

export function useSendPrefs() {
  const [p, setP] = useState(readPrefs);
  useEffect(() => {
    const on = () => setP(readPrefs());
    window.addEventListener("wall:video-prefs", on);
    window.addEventListener("storage", on);
    return () => { window.removeEventListener("wall:video-prefs", on); window.removeEventListener("storage", on); };
  }, []);
  const set = (patch) => {
    localStorage.setItem(KEY, JSON.stringify({ ...readPrefs(), ...patch }));
    window.dispatchEvent(new Event("wall:video-prefs"));
  };
  return [p, set];
}
